var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solutions container"},[_c('hp-catalog-table',{attrs:{"table-cfg":_vm.catalogTableCfg,"isAllSolutions":"table-cfg.isAllSolutions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }